"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const joi = require("@hapi/joi");
const validateJoi_1 = require("./validateJoi");
/**
 * Validates inputs and outputs to async functions with joi schemas
 */
function Validate(input, output = joi.empty()) {
    return function (_target, _propertyKey, descriptor) {
        const validateInput = validateJoi_1.validateJoi(input);
        const validateOutput = validateJoi_1.validateJoi(output);
        const original = descriptor.value;
        async function validated(...args) {
            const payload = args.length === 1 ? [validateInput(args[0])] : validateInput(args);
            const promise = original.apply(this, payload);
            const response = await promise;
            return validateOutput(response);
        }
        descriptor.value = validated;
        return descriptor;
    };
}
exports.Validate = Validate;
